import gql from 'graphql-tag'

export default gql`
mutation UpdateScheduleTask($id: ID!, $taskType: ScheduleTaskType!, $fields: ScheduleTaskUpdateInput!) {
  cashAssist {
    updateScheduleTask(id: $id, taskType: $taskType, fields: $fields) {
      id: taskId
    }
  }
}
`
